/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProfileInfoCashDotApp} from '../api'

 export const useQueryGetProfileInfoCashDotApp = createReactQueryHook('getProfileInfoCashDotApp', getProfileInfoCashDotApp)
